module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "default-active": _vm.$route.path,
      "mode": "horizontal",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/home/subscribeCode/subscribeCode_Li"
    }
  }, [_vm._v("注册码记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/home/subscribeCode/createCode"
    }
  }, [_vm._v("生成注册码")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c18244","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/subscribeCode/subscribeCodeMenu.vue
// module id = 1011
// module chunks = 2